import { CommonModule, NgClass, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-indicator',
  templateUrl: './indicator.component.html',
  styleUrls: ['./indicator.component.scss'],
  standalone: true,
  imports: [
   CommonModule
  ],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class IndicatorComponent implements OnInit {
  @Input() indicator!: string | number;
  @Input() delta?: number;
  @Input() trend?:any;
  deltaRating!: string;
  trendRating!: string | string[];

  constructor() {

  }
  ngOnInit(): void {
    if (this.trend) {
      this.evaluateTrend();
    }
    else if (this.delta) {
      this.evaluateDelta();
    }
    
  }

  evaluateTrend() {
    if (Number(this.trend) > 0) {
      this.trendRating = ['di-trend-up','text-success'];
    } else if (Number(this.trend) < 0) {
      this.trendRating = ['di-trend-down','text-danger'];
    } else {
      this.trendRating = ['di-arrow-right','text-muted'];
    }
  }

  evaluateDelta() {
    if (Number(this.delta) > Number(this.indicator)) {
      this.deltaRating = 'positive';
    } else if (Number(this.delta) < Number(this.indicator)) {
      this.deltaRating = 'negative';
    } else {
      this.deltaRating = 'neutral';
    }
  }
  
}
